module.exports = __webpack_public_path__ + "static/media/roll.eb8c9f68.mp3";